import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

export const ModalWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 252px;
  height: 216px;
  background-color: #fff;
  justify-content: center;
  padding: 0 15px;
`;

export const ErrorText = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 24px;
  color: #777;
  text-align: center;
`;
